import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { CopyBlockContent } from 'src/redux/content/types';
import { selectPageType } from 'src/redux/navigation/selectors';
import { isTaxonomyPage } from 'src/utils/page';
import { selectMatchedTaxonomyEntry } from './selectMatchedTaxonomyEntry';

/**
 * The modular `copy_block` rendered below the product listing. The source is
 * decoupled by route: the taxonomy route reads it from the matched neighborhood
 * entry in `content.entries`, while the category route reads it from
 * `content.category`. Keeps `CopyBlockContainer` route-unaware.
 */
export const selectCopyBlockContent = (state: ReduxApplicationState): CopyBlockContent | null => {
  if (isTaxonomyPage(selectPageType(state))) {
    return selectMatchedTaxonomyEntry(state)?.content?.copyBlock ?? null;
  }

  return state.content?.category?.copyBlock ?? null;
};
